// removed by extract-text-webpack-plugin
module.exports = {"removed":"_2bRjBsKwrqLjQTCBmEif-w"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Recipe/style.scss
// module id = 1053
// module chunks = 0